import stone1 from '../assets/items/stone1.png'
import stone2 from '../assets/items/stone2.png'
import stone3 from '../assets/items/stone3.png'
import stone4 from '../assets/items/stone4.png'
import bossMaterial from '../assets/items/bossMaterial.png'
export const materials = [
    {
        id:'stone1',
        name:'2 ★',
        img : stone1
    },
    {
        id:'stone2',
        name:'3 ★',
        img : stone2
    },
    {
        id:'stone3',
        name:'4 ★',
        img : stone3
    },
    {
        id:'stone4',
        name:'5 ★',
        img : stone4
    },
    {
        id:'bossMaterial',
        name:'Boss',
        img : bossMaterial
    },
]
